import OSRedirect from './os-redirect';

export default OSRedirect;
